import Headcom from "../../src/components/Headcom";
import FooterCom from "../../src/components/FooterCom";
import FooterDis from "../../src/Description/FooterDis";
import FreeGameCom from "../../src/components/FreeGameCom";
import CookieCom from "../../src/components/CookieCom";
import GameCommonDis from "../../src/Description/GameCommonDis";
import { PageList } from "../../src/list/PageList";
import { FreeGames } from "../../src/list/FreeGames";
import { Assets } from "../../src/list/Assets";
import { useRouter } from "next/router";
import { useEffect } from "react";
import Link from "next/link";
import Snow_fx from "../../src/fx/Snow_fx";

export default function FreeGamesFor() {
  const path = useRouter();

  function gameLoad() {
    var myArray = [];
    var i;

    for (i = 0; i < FreeGames.length; i++) {
      myArray[i] = (
        <FreeGameCom
          key={i}
          title={FreeGames[i].title}
          thumb={FreeGames[i].thumb}
          iframe={FreeGames[i].iframe}
          zip={FreeGames[i].zip}
          Walkthrough={FreeGames[i].Walkthrough}
          dis={FreeGames[i].dis}
        />
      );
    }
    return myArray;
  }
  useEffect(() => {}, []);
  return (
    <div>
      <Headcom
        title={PageList[2].title}
        s_dis={PageList[2].s_dis}
        path={PageList[2].path[1] + PageList[2].path[0]}
        thumb={PageList[2].thumb}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />
      <div className="privacy-form">
        <div className="free_container">
          <Link href={"/"}>
            <a className="privacy-logo ">
              <img
                decoding="async"
                alt="Logo"
                title="logo"
                src={Assets[0].logo2}
              ></img>
            </a>
          </Link>
          <h1>Free Games For Your Site</h1>
          <p>
            We are happy to share our new games with the webmasters through free
            games for your site page. You can find an exciting and fun
            collection of games for girls. We would very much appreciate it if
            you could take a moment to review it and if you like it, feel free
            to publish it on your website. If you want to publish your games on
            our site, please use the submit games page to send your game to us.
            Our team will review your games and publish them on our site as soon
            as possible.
          </p>
          <p>
          If you like our games, then feel free to contact us we will help you to publish them on your website.
          </p>

          <p>
          You can send an email to <a>admin@fabboxstudios.com</a>
          </p>

          <div className="free_game_con">
            {gameLoad()}
          </div>
        </div>
      </div>
      <GameCommonDis />
      <FooterDis />
      <FooterCom />
      <Snow_fx />
      <CookieCom />
    </div>
  );
}
